import { render, staticRenderFns } from "./ChoiceSubject.vue?vue&type=template&id=6741942d&scoped=true&"
import script from "./ChoiceSubject.vue?vue&type=script&lang=js&"
export * from "./ChoiceSubject.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceSubject.vue?vue&type=style&index=0&id=6741942d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6741942d",
  null
  
)

export default component.exports